"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Source Icon Component
 *
 * Tree-shakeable icon component for source indicators.
 *
 * @example
 * ```tsx
 * import Source from '@insided/destination/icons/Source'
 *
 * <Source width={16} height={16} />
 * ```
 */
var Source = function Source(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Source",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M11.9875 20.4C9.64583 20.4 7.6625 20.0513 6.0375 19.3538C4.4125 18.6563 3.6 17.805 3.6 16.8V7.20001C3.6 6.20001 4.41667 5.35001 6.05 4.65001C7.68333 3.95001 9.6625 3.60001 11.9875 3.60001C14.3125 3.60001 16.2958 3.95001 17.9375 4.65001C19.5792 5.35001 20.4 6.20001 20.4 7.20001V16.8C20.4 17.805 19.5833 18.6563 17.95 19.3538C16.3167 20.0513 14.3292 20.4 11.9875 20.4ZM11.9992 9.00001C13.4331 9.00001 14.8167 8.82084 16.15 8.46251C17.4833 8.10417 18.3 7.68334 18.6 7.20001C18.3 6.73334 17.4792 6.31667 16.1375 5.95001C14.7958 5.58334 13.4164 5.40001 11.9992 5.40001C10.5664 5.40001 9.17917 5.58334 7.8375 5.95001C6.49583 6.31667 5.68333 6.73334 5.4 7.20001C5.68333 7.68334 6.4875 8.10417 7.8125 8.46251C9.1375 8.82084 10.5331 9.00001 11.9992 9.00001ZM12 13.8C12.7 13.8 13.3667 13.7625 14 13.6875C14.6333 13.6125 15.2292 13.5083 15.7875 13.375C16.3458 13.2417 16.8625 13.0708 17.3375 12.8625C17.8125 12.6542 18.2333 12.4167 18.6 12.15V9.42501C18.1958 9.64534 17.749 9.84209 17.2595 10.0153C16.7698 10.1884 16.2431 10.3321 15.6792 10.4463C15.1154 10.5604 14.5237 10.6479 13.9042 10.7088C13.2847 10.7696 12.6458 10.8 11.9875 10.8C11.3292 10.8 10.6866 10.7696 10.0597 10.7088C9.43275 10.6479 8.84108 10.5604 8.28475 10.4463C7.72825 10.3321 7.20417 10.1875 6.7125 10.0125C6.22083 9.83751 5.78333 9.64167 5.4 9.42501V12.15C5.7735 12.4157 6.19192 12.6529 6.65525 12.8618C7.11842 13.0706 7.62917 13.2417 8.1875 13.375C8.74583 13.5083 9.34583 13.6125 9.9875 13.6875C10.6292 13.7625 11.3 13.8 12 13.8ZM12.008 18.6C12.73 18.6 13.4637 18.5467 14.2092 18.44C14.9547 18.3335 15.6414 18.1927 16.2693 18.0175C16.8971 17.8425 17.4228 17.6446 17.8465 17.4238C18.2703 17.2029 18.5215 16.9783 18.6 16.75V14.225C18.1958 14.4453 17.749 14.6421 17.2595 14.8153C16.7698 14.9884 16.2431 15.1321 15.6792 15.2463C15.1154 15.3604 14.5237 15.4479 13.9042 15.5088C13.2847 15.5696 12.6458 15.6 11.9875 15.6C11.3292 15.6 10.6866 15.5696 10.0597 15.5088C9.43275 15.4479 8.84108 15.3604 8.28475 15.2463C7.72825 15.1321 7.20417 14.9875 6.7125 14.8125C6.22083 14.6375 5.78333 14.4417 5.4 14.225V16.8C5.48333 17.0167 5.7375 17.2333 6.1625 17.45C6.5875 17.6667 7.1125 17.8583 7.7375 18.025C8.3625 18.1917 9.05 18.3292 9.8 18.4375C10.55 18.5458 11.286 18.6 12.008 18.6Z",
    fill: "currentColor"
  }));
};

var _default = Source;
exports.default = _default;